import { Box, Flex } from '@chakra-ui/react';
import {
  Dropdown,
  DropdownTrigger,
  ChevronDown,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  Icon,
} from '@mesh.ai/rabbit';
import { type CompetencyDetails } from 'Deer/pages/MyData/Overview/types/FeedbackMyOverview';
import { truncate } from 'utils/lib';

import { TextBodyMedium, TextHeader4, TextLabel } from 'uiToolkitV1/Typography';

type CompetencyHeaderProps = {
  selectedCompetency: CompetencyDetails;
  setSelectedCompetency: (competency: CompetencyDetails) => void;
  competencyDetails: CompetencyDetails[];
};

export const CompetencyHeader = ({
  selectedCompetency,
  setSelectedCompetency,
  competencyDetails,
}: CompetencyHeaderProps) => (
  <Box p="4px 8px" m="8px 12px" borderBottom="1px solid #CFD7DF">
    <TextHeader4 bold padding="4px">
      Competency initiatives
    </TextHeader4>

    <Box display="flex" alignItems="center" gap="8px" alignSelf="stretch">
      <Box display="flex" padding="4px" alignItems="center" gap="12px" alignSelf="stretch">
        <TextLabel color="text.g2">Competencies : </TextLabel>
      </Box>
      <Dropdown>
        <Box
          sx={{
            'button[data-state="open"]': {
              borderBottom: '1px solid #0D819F',
            },
            'button[data-state="closed"]': {
              borderBottom: '1px dashed #999999',
            },
            'button[data-state="open"] .icon': {
              color: '#0D819F',
              transform: 'rotate(180deg)',
              transition: 'transform 0.2s',
            },
            "button[data-state='closed'] .icon": {
              color: '#333333',
            },
            button: { width: '412px' },
          }}
        >
          <DropdownTrigger>
            <Flex alignItems="center" padding="10px 12px 10px 8px" gap="8px">
              <TextBodyMedium bold maxW="100%" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                {selectedCompetency.competencyName}
              </TextBodyMedium>
              <Box ml="auto">
                <Box>
                  <Icon className="icon" IconSVG={ChevronDown} />
                </Box>
              </Box>
            </Flex>
          </DropdownTrigger>
          <DropdownContent
            align="start"
            style={{ minWidth: '412px', padding: '8px', maxHeight: '500px', overflowY: 'auto' }}
          >
            <DropdownRadioGroup value={selectedCompetency.competencyName}>
              {competencyDetails?.map((competency) => (
                <DropdownRadioItem
                  style={{
                    marginBottom: '4px',
                    borderRadius: '4px',
                  }}
                  key={competency.competencyId}
                  value={competency.competencyName}
                  onClick={() => setSelectedCompetency(competency)}
                >
                  <Box display="flex" flexDirection="column" alignItems="flex-start" flex="1 0 0" maxW="100%">
                    <TextBodyMedium bold maxW="100%">
                      {competency.competencyName}
                    </TextBodyMedium>
                    <TextLabel color="text.g2" maxW="100%">
                      {competency.competencyDescription ? truncate(competency.competencyDescription, 110) : ''}
                    </TextLabel>
                  </Box>
                </DropdownRadioItem>
              ))}
            </DropdownRadioGroup>
          </DropdownContent>
        </Box>
      </Dropdown>
    </Box>
  </Box>
);
